"use client";

import { useEffect } from "react";
import { captureAdsContext } from "../../lib/analytics/attribution";

/** Übernimmt `ia_src` / Google-Click-IDs aus der URL (Cookie + dataLayer), einmal je Seitenaufruf. */
export function AdsContextCapture() {
  useEffect(() => {
    captureAdsContext();
  }, []);
  return null;
}
